import React, { useEffect, useState } from "react";
import { Theme, ThemeLayout } from "./pages/Styles/Theme";
import { ThemeProvider } from "styled-components";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import Dashboard from "./pages/Dashboard/Dashboard";
import "./pages/index.css";
import Sidebar from "./Components/Sidebar/Sidebar";
import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import CreatePollingAgent from "./pages/PollingAgents/CreatePollingAgent";
import PollingAgents from "./pages/PollingAgents/PollingAgent";
import PollAgents from "./pages/PollingAgents/PollAgents";
import Campaigns from "./pages/Campaigns/Campaigns";
import CreateCampaign from "./pages/Campaigns/CreateCampaign";
import CampaignDetail from "./pages/Campaigns/CampaignDetail";
import CampaignLandingPage from "./pages/Campaigns/CampaignLandingPage";
import SurveysList from "./pages/Surveys/SurveysList";
import SetUpStudy from "./pages/Surveys/SetUpStudy";
import Preview from "./pages/Surveys/SurveyComponents/Preview/Preview";
import Project from "./pages/Projects/Project";
import ProjectDetails from "./pages/Projects/ProjectDetails";
import DefaultGpt from "./pages/Projects/DefaultGpt";
import GptChat from "./pages/Projects/GptChat";
import Share from "./pages/Surveys/Share/Share";
import { GlobalMasterStyle } from "./pages/Styles/MasterStyle";
import Gpt from "./pages/Projects/Gpt";
import InsightEngineChat from "./pages/Projects/InsightEngineChat";
import CreateSurvey from "./pages/Surveys/CreateSurvey";
import LaunchSurvey from "./pages/Surveys/LaunchSurvey";
import Login from "./pages/Login/Login";
import PrivateRoute from "./Components/common/PrivateRoute";
import NotFoundPage from "./Components/common/NotFoundPage";
import { useDispatch } from "react-redux";
import { initializeAuth } from "./store/actions/loginAction";
import { initializePermissions } from "./store/actions/permissionsAction";
import { getAppVersionApi } from "./store/actions/settingAction";
import { getUserToken } from "./utils/helpers";
import Manage from "./pages/Manage/Manage";
import Organization from "./pages/Organization/Organization";
import AddEditOrganization from "./pages/Organization/AddEditOrganization";
import SurveyEntry from "./pages/SurveyEntry/SurveyEntry";
import InsightEngine from "./pages/Projects/InsightEngine";
import VerifyInvitation from "./pages/VerifyInvitation/VerifyInvitation";
import SetPassword from "./pages/SetPassword/SetPassword";

// Initialize auth on app load
const AppInitializer = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Initialize auth and permissions from localStorage
    dispatch(initializeAuth());
    dispatch(initializePermissions());
    if (getUserToken()) {
      dispatch(getAppVersionApi());
    }
  }, [dispatch]);

  return <>{children}</>;
};

// Layout component that includes sidebar and header for all pages
const AppLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const toggle = (data) => {
    setCollapsed(data);
  };

  return (
    <>
      <GlobalMasterStyle />
      <ThemeLayout>
        <Sidebar
          collapsed={collapsed}
          collapsedWidth={60}
          toggle={(data) => toggle(data)}
        />
        <Layout>
          <Content
            className="mainContent"
            style={{
              marginLeft: window.innerWidth <= 991 ? 0 : collapsed ? 60 : 210,
              width:
                window.innerWidth <= 991
                  ? "100%"
                  : collapsed
                  ? "calc(100% - 60px)"
                  : "calc(100% - 210px)",
              transition: "all 0.2s ease",
            }}
          >
            <div
              style={{
                marginLeft: "0px",
                width: "100%",
              }}
            >
              <main className="px-5 py-4">
                <Outlet />
              </main>
            </div>
          </Content>
        </Layout>
      </ThemeLayout>
    </>
  );
};

// Layout component without sidebar and header
const NoSidebarLayout = () => {
  return (
    <>
      <GlobalMasterStyle />
      <ThemeLayout>
        <Layout>
          <Content
            className="mainContentNoSidebar"
            style={{
              marginLeft: 0,
              width: "100%",
              transition: "all 0.2s ease",
            }}
          >
            <main className="p-0">
              <Outlet />
            </main>
          </Content>
        </Layout>
      </ThemeLayout>
    </>
  );
};

// Define routes
const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  // Public route for campaign landing page (no auth required)
  {
    path: "/campaign/:slug/:code",
    element: <CampaignLandingPage />,
  },
  {
    path: "/",
    element: (
      <PrivateRoute>
        <AppLayout />
      </PrivateRoute>
    ),
    children: [
      {
        path: "/",
        element: <Dashboard />,
      },
      {
        path: "/polling-agents/",
        element: <PollAgents />,
      },
      {
        path: "/polling-agents/polling-agent",
        element: <PollingAgents />,
      },
      {
        path: "/polling-agents/polling-agent/create-polling-agent",
        element: <CreatePollingAgent />,
      },
      {
        path: "/polling-agents/polling-agent/create-polling-agent/:id",
        element: <CreatePollingAgent />,
      },
      {
        path: "/campaigns/",
        element: <Campaigns />,
      },
      {
        path: "/campaigns/create-campaign",
        element: <CreateCampaign />,
      },
      {
        path: "/campaigns/create-campaign/:id",
        element: <CreateCampaign />,
      },
      {
        path: "/campaigns/:id",
        element: <CampaignDetail />,
      },
      {
        path: "/projects/",
        element: <Project />,
      },
      {
        path: "/projects/details/:id",
        element: <ProjectDetails />,
      },
      {
        path: "/insight-engine/",
        element: <InsightEngine />,
      },
      {
        path: "/insight-engine/gpt",
        element: <Gpt />,
      },
      {
        path: "/insight-engine/default",
        element: <DefaultGpt />,
      },
      {
        path: "/insight-engine/:chatId",
        element: <InsightEngineChat />,
      },
      {
        path: "/surveys/",
        element: <SurveysList />,
      },
      {
        path: "/surveys/launch-survey",
        element: <LaunchSurvey />,
      },
              {
                path: "/manage",
                element: <Manage />,
              },
              {
                path: "/organizations",
                element: <Organization />,
              },
              {
                path: "/organizations/new",
                element: <AddEditOrganization />,
              },
              {
                path: "/organizations/:id",
                element: <AddEditOrganization />,
              },
    ],
  },
  // Separate route for Study page without sidebar
  {
    path: "/surveys/study",
    element: (
      <PrivateRoute>
        <NoSidebarLayout />
      </PrivateRoute>
    ),
    children: [
      {
        path: "/surveys/study/:surveyId",
        element: <CreateSurvey />,
      },
      {
        path: "/surveys/study/set-up-study",
        element: <SetUpStudy />,
      },
      {
        path: "/surveys/study/set-up-study/preview",
        element: <Preview />,
      },
      {
        path: "/surveys/study/set-up-study/share/",
        element: <Share />,
      },
    ],
  },
  {
    path: "/survey-entry",
    element: <SurveyEntry />,
  },
  // Public routes for user registration flow
  {
    path: "/auth/xv7k2m/:token",
    element: <VerifyInvitation />,
  },
  {
    path: "/auth/np2w8q",
    element: <SetPassword />,
  },
  // Catch-all route for 404 - must be last
  {
    path: "*",
    element: <NotFoundPage />,
  },
]);

function App() {
  return (
    <ThemeProvider theme={Theme}>
      <AppInitializer>
        <RouterProvider router={router} />
      </AppInitializer>
    </ThemeProvider>
  );
}

export default App;
